export enum VideoTypeValue {
  MY_VIDEO = 'my-video',
  BLOCKS_VIDEO = 'blocks-video',
  SYSTEM_VIDEO = 'system-video',
}

export type VideoType = VideoTypeValue.MY_VIDEO | VideoTypeValue.BLOCKS_VIDEO | VideoTypeValue.SYSTEM_VIDEO;
